import { useEffect, useRef, useState } from 'react';
import type { NoteKind } from '@/domain/note';
import { Icon } from '@/ui/Icon';

/** M3 Expressive FAB menu: one FAB that expands into "Notiz" / "Liste". */
export function FabMenu({ onCreate }: { onCreate: (kind: NoteKind) => void }) {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e: KeyboardEvent) => e.key === 'Escape' && setOpen(false);
    const onDown = (e: MouseEvent) => !ref.current?.contains(e.target as Node) && setOpen(false);
    document.addEventListener('keydown', onKey);
    document.addEventListener('mousedown', onDown);
    return () => {
      document.removeEventListener('keydown', onKey);
      document.removeEventListener('mousedown', onDown);
    };
  }, [open]);

  const pick = (kind: NoteKind) => {
    setOpen(false);
    onCreate(kind);
  };

  return (
    <div className={`fab-menu${open ? ' is-open' : ''}`} ref={ref}>
      {open && (
        <div className="fab-menu__items" role="menu" aria-label="Neu erstellen">
          <button type="button" role="menuitem" className="fab-menu__item" onClick={() => pick('todo')}>
            <Icon name="checklist" />
            Liste
          </button>
          <button type="button" role="menuitem" className="fab-menu__item" onClick={() => pick('text')}>
            <Icon name="edit_note" />
            Notiz
          </button>
        </div>
      )}
      <button
        type="button"
        className="fab"
        aria-label={open ? 'Menü schließen' : 'Neu erstellen'}
        aria-haspopup="menu"
        aria-expanded={open}
        onClick={() => setOpen((o) => !o)}
      >
        <Icon name={open ? 'close' : 'add'} size={28} />
      </button>
    </div>
  );
}
